export default class Operation {
  getDetailURL() {
    return `/promotion/mobile-push-operations/${this.id}`;
  }
  getEditableURL() {
    return `/promotion/mobile-push-operations/${this.id}${this.isEditable() ? '/edit' : ''}`;
  }
  isCancelable() {
    return ['draft', 'submitted', 'pending', 'approved'].includes(this.status);
  }
  isEditable() {
    return this.status === 'draft';
  }
  isPendingApproval() {
    return this.status === 'pending';
  }
}
